/**
 * Small brand marks for the payment-method picker (LLMR-116/121) — sized to
 * sit inline with the row's own text, not full checkout-page logos.
 *
 * These are the real logo files (assets/brand/*), user-supplied, not a
 * hand-drawn approximation — an earlier hand-drawn SVG round looked
 * untrustworthy at this size and was rejected. PromptPayMark's own logo is
 * also used at a larger size in components/QRCard.tsx.
 */
import jcbLogo from '../assets/brand/jcb-logo.png';
import mastercardLogo from '../assets/brand/mastercard-logo.svg';
import promptPayLogo from '../assets/brand/promptpay-logo.png';
import visaLogo from '../assets/brand/visa-logo.png';

const MARK_HEIGHT = 16;

export function VisaMark() {
  return <img src={visaLogo} alt="Visa" className="pay-mark" style={{ height: MARK_HEIGHT }} />;
}

export function MastercardMark() {
  return <img src={mastercardLogo} alt="Mastercard" className="pay-mark" style={{ height: MARK_HEIGHT }} />;
}

export function JcbMark() {
  return <img src={jcbLogo} alt="JCB" className="pay-mark" style={{ height: MARK_HEIGHT }} />;
}

export function PromptPayMark() {
  return <img src={promptPayLogo} alt="PromptPay" className="pay-mark" style={{ height: MARK_HEIGHT }} />;
}
